import React, { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useWindowWith from "hooks/useWindowWidth";


function CarruselDos({ children }) {
  const [clicked, setClicked] = useState(false);
  const ancho = useWindowWith();
  console.log(ancho);
  
  const handleMouseDown = () => {
    setClicked(true);
  };
  const handleMouseUp = () => {
    setClicked(false);
  };
  // const [width, setWidth] = useState(window.innerWidth);
  // console.log(window.innerWidth);
  // console.log(screen.width);
  
  
  // useEffect(() => {
  //   const handleResize = () => {
  //     setWidth(window.innerWidth);
  //   };
  //   window.addEventListener("resize", handleResize);
  //   return () => {
  //     window.removeEventListener("resize", handleResize);
  //   };
  // }, []);
  
  var settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: ancho >= 500 ? (ancho > 768 ? (ancho > 1024 ? 3 : 3) : 2) : 1,
    slidesToScroll: ancho >= 500 ? (ancho > 768 ? (ancho > 1024 ? 3 : 3) : 2) : 1,
    initialSlide: 0,
  };
  return (
    <div
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      className={`w-full overflow-hidden ${clicked ? "cursor-grabbing" : "cursor-grab"} pb-5`}
    >
      <Slider {...settings}>
        {children.map((item, index) => {
          return (
            <div key={index} className="p-4 pb-4">
              {item}
            </div>
          );
        })}
      </Slider>
    </div>
  );
}

export default CarruselDos;
